
import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import CreateUUID from "../guid";

@Component({})

export default class DropdownSelector extends Vue {
    @Prop({default: () => []})
    errorMessages!: string[];

    @Prop({required: false, default: () => CreateUUID()})
    id!: string;

    @Prop({default: () => ''})
    label!: string;

    @Prop({default: false})
    disabled!: boolean;

    @Prop({default: () => ([])})
    options!: string[];

    @Prop({default: () => ''})
    value!: string;

    @Prop({default: () => "value"})
    valueField!: string;

    @Prop({default: () => "text"})
    textField!: string;

    created() {
        this.$watch(() => this.value, newValue => {
            this.selectedValue = newValue;
            this.$emit('change', this.selectedValue);
        }, {immediate: true});
    }

    selectedValue = this.value;

    selectValue() {
        this.$emit('input', this.selectedValue);
    }
}
